module.exports = __webpack_public_path__ + "img/icon_1_37.69b250aa.png";